import React from "react";
import {
  Tabs,
  Tab,
  Box,
  Button,
  Paper,
  withStyles,
  makeStyles,
} from "@material-ui/core";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import axios from "axios";
import toastr from "toastr";
import { domain } from "../../utils/util";

// Custom Tab Styling
const StyledTabs = withStyles({
  // root: {
  //   borderBottom: "2px solid #1976d2",
  // },
  indicator: {
    backgroundColor: "#1976d2",
  },
})(Tabs);

const StyledTab = withStyles((theme) => ({
  root: {
    minWidth: 150,
    textTransform: "none",
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(1),
    "&:hover": {
      color: "#1976d2",
      opacity: 1,
    },
    "&$selected": {
      color: "#1976d2",
      fontWeight: theme.typography.fontWeightMedium,
    },
    "&:focus": {
      color: "#1976d2",
    },
  },
  selected: {},
}))(Tab);

// Custom styles for wrapper
const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    backgroundColor: "#f5f5f5",
    minHeight: "100vh",
    
  },
  // editorWrapper: {
  //   border: "1px solid #1976d2",
  //   borderRadius: 4,
  //   marginTop: theme.spacing(2),
  //   padding: theme.spacing(2),
  //   backgroundColor: "#fff",
  // },
  // quill: {
  //   height: 300,
  //   marginBottom: theme.spacing(2),
  // },
  // saveButton: {
  //   marginTop: theme.spacing(2),
  // },
}));

const StaticContent = () => {
  const classes = useStyles();

  const [tabIndex, setTabIndex] = React.useState(0);
  const [privacyContent, setPrivacyContent] = React.useState("");
  const [legalContent, setLegalContent] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    fetchPolicy("privacyPolicy");
    fetchPolicy("legal");
  }, []);

  const fetchPolicy = (type) => {
    const data = JSON.parse(localStorage.getItem("BerPay_Admin"));
    const config = {
      headers: {
        Authorization: `Bearer ${data?.token || ""}`,
        "Content-Type": "multipart/form-data",
      },
    };

    const url =
      type === "privacyPolicy"
        ? `${domain}/setting/static/privacyPolicy`
        : `${domain}/setting/static/legal`;

    axios.get(url, config).then((res) => {
      if (res.data.statusCode === 200) {
        const content = res.data.data[0]?.content || "";
        if (type === "privacyPolicy") {
          setPrivacyContent(content);
        } else {
          setLegalContent(content);
        }
      }
    });
  };

  const handleTabChange = (_, newValue) => {
    setTabIndex(newValue);
  };

  const saveContent = async (type) => {
    const contentBody = type === "privacyPolicy" ? privacyContent : legalContent;
    const data = JSON.parse(localStorage.getItem("BerPay_Admin"));
    const config = {
      headers: {
        Authorization: `Bearer ${data?.token || ""}`,
        "Content-Type": "application/json",
      },
    };

    const payload = { type, contentBody };
    setLoading(true);

    try {
      const res = await axios.post(
        `${domain}/setting/upload/privacyPolicy`,
        payload,
        config
      );
      if (res.data.statusCode === 200 || res.data.statusCode === 201) {
        toastr.success(`${type} saved successfully`);
      }
    } catch (err) {
      toastr.error("Failed to save content");
    } finally {
      setLoading(false);
    }
  };

  const renderEditor = (type) => {
    const content = type === "privacyPolicy" ? privacyContent : legalContent;
    const setContent =
      type === "privacyPolicy" ? setPrivacyContent : setLegalContent;

    return (
      <Paper elevation={2} className={classes.editorWrapper}>
        {/* <h4>{type === "privacyPolicy" ? "Privacy Policy" : "Legal Policy"}</h4> */}
        <ReactQuill
          value={content}
          onChange={setContent}
          className={classes.quill}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={() => saveContent(type)}
          className={classes.saveButton}
          // disabled={loading}
        >
          { `Save/Update ${type === "privacyPolicy" ? "Privacy" : "Legal"} Policy`}
        </Button>
      </Paper>
    );
  };

  return (
    <div className={classes.root}>
      <StyledTabs value={tabIndex} onChange={handleTabChange}  style={{ marginRight: 380 }}>
        <StyledTab label="Privacy Policy" />
        <StyledTab label="Legal Policy" />
      </StyledTabs>
      <Box mt={3}>
        {tabIndex === 0 && renderEditor("privacyPolicy")}
        {tabIndex === 1 && renderEditor("legal")}
      </Box>
    </div>
  );
};

export default StaticContent;
